var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"started-footer"},[_c('span',[_vm._v("Copyright © "+_vm._s(_vm.year)+" AtomicMind. All rights reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }